import SeleksiVendorPurchaseOrder from './SeleksiVendorPurchaseOrder'

export default SeleksiVendorPurchaseOrder